import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";

import SalesUserSideMenu from "../../../menu/SalesUserSideMenu";
import Header from "../../common/Header";
import { ANY_ERROR } from "../../../action/user_action_types";
import { endPoints, fileUrl } from "../../../config";
import { history } from "../../../history/history";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import SideBar from "../common/sideBar";
import { axiosInstnace } from "../../../util/util";
import { toast, ToastContainer } from "react-toastify";
import StatusHistory from "./statushistory";

class ViewDSA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campaign: this.props.dsa,
      statelist: this.props.stationlist,
      adminInfo: JSON.parse(localStorage.getItem("adminInfo")),
      mentorname: "",
      editmentor: false,
      mentornum: "",
      historyview: false,
      mentorlist: [],
      validation: {
        station: React.createRef(),
        mentor: React.createRef(),
        sapId: React.createRef(),
        comments: React.createRef(),
      },
    };
  }
  componentDidMount() {
    if (this.props.dsa) {
      this.getusers(this.props.dsa.station);
    }
    if (
      this.state.campaign &&
      this.state.campaign.kycstatus &&
      this.state.campaign.kycstatus.status === "Submitted"
    ) {
      let { campaign } = this.state;
      campaign.kycstatus.message = "";
      this.setState({ campaign });
    }
  }
  setmentordetails = (evt) => {
    let mentor = this.state.mentorlist.find(
      (e) => e.email === evt.target.value
    );
    this.setState({
      mentorname: mentor ? mentor.name : "",
      mentornum: mentor ? mentor.mobile : "",
    });
  };
  hideshowhistory = (e) => {
    
    this.setState({
      historyview: !this.state.historyview,
    });
  };
  rejectDSA = async (e) => {
    try {
      e.preventDefault();
      if (!this.state.validation.comments.current.value.trim()) {
        toast.error(
          "Please enter the rejection comments to reject the Trade Partner",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: false,
            toastId: "1",
          }
        );
        if (!this.state.validation.comments.current.value) {
          this.state.validation.comments.current.style.border = "2px solid red";
        }
        return;
      }
      let updatedoc = {
        kycstatus: {
          status: "Rejected",
          message: this.state.validation.comments.current.value,
          actionby: this.state.adminInfo.email,
          time: +new Date(),
        },
        name: this.state.campaign.name,
        email: this.state.campaign.email,
      };
      updatedoc.previousKycStatuses = this.state.campaign.previousKycStatuses;
      updatedoc.previousKycStatuses.push(updatedoc.kycstatus);
      
      await axiosInstnace.post(endPoints.dsauserupdate, updatedoc);
      window.location.reload(true);
    } catch (err) {
      console.log(err);
    }
  };
  approveDSA = async (e) => {
    try {
      e.preventDefault();
      if (
        !this.state.validation.mentor.current.value.trim() ||
        !this.state.validation.station.current.value.trim() ||
        !this.state.validation.sapId.current.value.trim()
      ) {
        toast.error(
          "Please select both the station and mentor and mention the Vendor ID to approve the Trade Partner",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: false,
            toastId: "1",
          }
        );
        if (!this.state.validation.mentor.current.value) {
          this.state.validation.mentor.current.style.border = "2px solid red";
        }
        if (!this.state.validation.station.current.value) {
          this.state.validation.station.current.style.border = "2px solid red";
        }
        if (!this.state.validation.sapId.current.value) {
          this.state.validation.sapId.current.style.border = "2px solid red";
        }
        return;
      }
      let updatedoc = {
        kycstatus: {
          status: "Verified",
          message: "verified Successfully",
          actionby: this.state.adminInfo.email,
          time: +new Date(),
        },
        email: this.state.campaign.email,
        station: this.state.validation.station.current.value,
        mentorID: this.state.validation.mentor.current.value,
        sapId: this.state.validation.sapId.current.value,
        name: this.state.campaign.name,
        status: "Verified",
      };
      updatedoc.previousKycStatuses = this.state.campaign.previousKycStatuses;
      updatedoc.previousKycStatuses.push(updatedoc.kycstatus);
      await axiosInstnace.post(endPoints.dsauserupdate, updatedoc);
      window.location.reload(true);
    } catch (err) {
      console.log(err);
    }
  };
  getusers = async (city) => {
    let users = await axiosInstnace.get(endPoints.getusersofcity, {
      params: {
        city: city,
        role: ["salesUser", "stationAdmin"],
      },
    });
    
    this.setState({
      mentorlist: users.data.data,
    });
  };

  goToRoute = (route) => {
    history.push(route);
  };

  //Show campaign info
  render() {
    let { campaign } = this.state;
    return (
      <div>
        <div className="dashboardContainer">
          <HeaderAdminpanel />
          <div className="dashboardContainer-inner">
            <section id="sidebar">
              <SideBar />
            </section>
            <section
              id="dashboard-rightContainer"
              className="dashboard-manageSales brands-head"
            >
              <div className="container-head print_head">
                <div className="dashboard-breadcrumb">
                  Trade Partner Management | Trade Partner List |
                  <span className="blue_camp"> Trade Partner Detail</span>
                </div>
              </div>
              <div className="camplist_detail_wrapper">
                <div className="camplist_detail_left">
                  <div className="camplist_left_inner">
                    <div className="camplist_data">
                      <span className="camplist_head"> Name</span>
                      <span className="camplist_name">{campaign.name}</span>
                    </div>
                    <div className="camplist_data">
                      <span className="camplist_head">Father Name</span>
                      <span className="camplist_name">
                        {campaign.fathername}
                      </span>
                    </div>
                    {campaign.company && (
                      <div className="camplist_data" style={{marginRight:"10px"}}>
                        <span className="camplist_head">Company</span>
                        <span className="camplist_name">
                          {campaign.company}
                        </span>
                      </div>
                    )}

                    <div className="camplist_data">
                      <span className="camplist_head">Email</span>
                      <span className="camplist_name">{campaign.email}</span>
                    </div>
                  </div>
                  <div className="camplist_left_inner">
                    <div className="camplist_data">
                      <span className="camplist_head">Mobile Number</span>
                      <span className="camplist_name">{campaign.mobile}</span>
                    </div>
                    <div className="camplist_data">
                      <span className="camplist_head">Date of Birth</span>
                      <span className="camplist_name">
                        {campaign.dob &&
                          moment(parseInt(campaign.dob)).format("DD MMMM YYYY")}
                      </span>
                    </div>
                    <div className="camplist_data">
                      <span className="camplist_head">Pin Code</span>
                      <span className="camplist_name">
                        {campaign.communication &&
                          campaign.communication.pincode}
                      </span>
                    </div>
                  </div>
                  <div className="camplist_left_inner">
                    <div className="camplist_data">
                      <span className="camplist_head">Address</span>
                      <span className="camplist_name">
                        {campaign.communication &&
                          campaign.communication.address &&
                          campaign.communication.address.plot}
                        {campaign.communication &&
                        campaign.communication.address &&
                        campaign.communication.address.plot &&
                        campaign.communication.address.street
                          ? " , "
                          : ""}
                        {campaign.communication &&
                          campaign.communication.address &&
                          campaign.communication.address.street}
                      </span>
                    </div>
                    <div className="camplist_data">
                      <span className="camplist_head">City</span>
                      <span className="camplist_name">{campaign.city}</span>
                    </div>
                    <div className="camplist_data">
                      <span className="camplist_head">State</span>
                      <span className="camplist_name">{campaign.state}</span>
                    </div>
                  </div>
                  <div className="gst_detail">
                    <div className="gst_detail_inner">
                      <div className="gstdetail">
                        <span>Image</span>
                        <div className="download_gst">
                          {campaign.uploadeddocuments &&
                            campaign.uploadeddocuments.image_link && (
                              <div className="downloadaudio_file gst_file">
                                <a
                                  href={campaign.uploadeddocuments.image_link}
                                  download
                                  target="__blank"
                                >
                                  Download User Image
                                </a>
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="gstdetail">
                        <span>Address Proof</span>
                        <div className="download_gst">
                          {campaign.uploadeddocuments &&
                            campaign.uploadeddocuments.addressproof_link && (
                              <div className="downloadaudio_file gst_file">
                                <a
                                  href={
                                    campaign.uploadeddocuments.addressproof_link
                                  }
                                  download
                                  target="__blank"
                                >
                                  Download Address Proof
                                </a>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="gst_detail">
                    <h2 className="campview-detail_header gst_detail_header">
                      PAN Details
                    </h2>
                    <div className="gst_detail_inner">
                      <div className="gstdetail">
                        <span>PAN Number</span>
                        <span>
                          {campaign.kycdetails
                            ? campaign.kycdetails.pannumber
                            : ""}
                        </span>
                      </div>
                      <div className="gstdetail">
                        <span>PAN Certificate</span>
                        <div className="download_gst">
                          {campaign.uploadeddocuments &&
                            campaign.uploadeddocuments.pan_link && (
                              <div className="downloadaudio_file gst_file">
                                <a
                                  href={campaign.uploadeddocuments.pan_link}
                                  download
                                  target="__blank"
                                >
                                  Download Certificate
                                </a>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gst_detail">
                    <h2 className="campview-detail_header gst_detail_header">
                      Aadhar Details
                    </h2>
                    <div className="gst_detail_inner">
                      <div className="gstdetail">
                        <span>Aadhar Number</span>
                        <span>
                          {campaign.kycdetails
                            ? campaign.kycdetails.aadharnumber
                            : ""}
                        </span>
                      </div>
                      <div className="gstdetail">
                        <span>Aadhar Copy</span>
                        <div className="download_gst">
                          {campaign.uploadeddocuments &&
                            campaign.uploadeddocuments.aadhar_link && (
                              <div className="downloadaudio_file gst_file">
                                <a
                                  href={campaign.uploadeddocuments.aadhar_link}
                                  download
                                  target="__blank"
                                >
                                  Download Certificate
                                </a>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="gst_detail">
                    <h2 className="campview-detail_header gst_detail_header">
                      GST Details
                    </h2>
                    <div className="gst_detail_inner">
                      <div className="gstdetail">
                        <span>GST Number</span>
                        <span>
                          {campaign.kycdetails
                            ? campaign.kycdetails.gstnumber
                            : ""}
                        </span>
                      </div>
                      <div className="gstdetail">
                        <span>GST Certificate</span>
                        <div className="download_gst">
                          {campaign.uploadeddocuments &&
                            campaign.uploadeddocuments.gst_link && (
                              <div className="downloadaudio_file gst_file">
                                <a
                                  href={campaign.uploadeddocuments.gst_link}
                                  download
                                  target="__blank"
                                >
                                  Download Certificate
                                </a>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="gst_detail">
                    <h2 className="campview-detail_header gst_detail_header">
                      Account Details
                    </h2>
                    <div className="gst_detail_inner">
                      <div className="gstdetail">
                        <span>Account No</span>
                        <span>
                          {campaign.accountDetails &&
                            campaign.accountDetails.no}
                        </span>
                      </div>
                      <div className="gstdetail">
                        <span>Name</span>
                        <span>
                          {campaign.accountDetails &&
                            campaign.accountDetails.name}
                        </span>
                      </div>

                      <div className="gstdetail">
                        <span>IFSC Code</span>
                        <span>
                          {campaign.accountDetails &&
                            campaign.accountDetails.ifsc}
                        </span>
                      </div>

                      <div className="gstdetail">
                        <span>Account Proof</span>
                        <div className="download_gst">
                          {campaign.uploadeddocuments &&
                            campaign.uploadeddocuments.cancelledcheque_link && (
                              <div className="downloadaudio_file gst_file">
                                <a
                                  href={
                                    campaign.uploadeddocuments
                                      .cancelledcheque_link
                                  }
                                  download
                                  target="__blank"
                                >
                                  Download Bank Proof
                                </a>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gst_detail">
                    <h2 className="campview-detail_header gst_detail_header">
                      Reference Details
                    </h2>
                    <div className="gst_detail_inner">
                      <div className="gstdetail">
                        <span>Nearest Station</span>
                        <span>
                          {campaign.nearStation &&
                            campaign.nearStation}
                        </span>
                      </div>

                      <div className="gstdetail">
                        <span>Name</span>
                        <span>
                          {campaign.reference && campaign.reference.name}
                        </span>
                      </div>

                      <div className="gstdetail">
                        <span>Email Address</span>
                        <span>
                          {campaign.reference &&
                            campaign.reference.email}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="gst_detail">
                    <h2 className="campview-detail_header gst_detail_header">
                      Social Media
                    </h2>
                    <div className="gst_detail_inner">
                      <div className="gstdetail">
                        <span>Facebook</span>
                        <span>
                          {campaign.socialmedia &&
                            campaign.socialmedia.facebook}
                        </span>
                      </div>

                      <div className="gstdetail">
                        <span>Twitter</span>
                        <span>
                          {campaign.socialmedia && campaign.socialmedia.twitter}
                        </span>
                      </div>

                      <div className="gstdetail">
                        <span>linkeldn</span>
                        <span>
                          {campaign.socialmedia &&
                            campaign.socialmedia.linkeldn}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="gst_detail">
                    <h2 className="campview-detail_header gst_detail_header">
                      Station Mapping
                    </h2>
                    <div class="gst_detail_inner">
                      <div class="gstdetail">
                        <span class="detailinner_header"> Base Station </span>
                        <span>
                          {" "}
                          <select
                            class="packageType drop-down-icon"
                            name="state"
                            ref={this.state.validation.station}
                            value={this.state.campaign.station}
                            onChange={(e) => {
                              this.getusers(e.target.value);
                              this.setState({
                                campaign: {
                                  ...campaign,
                                  station: e.target.value,
                                },
                              });
                              e.target.style.removeProperty("border");
                            }}
                            disabled={
                              (campaign.kycstatus &&
                                campaign.kycstatus.status === "Submitted") ||
                              this.state.editmentor
                                ? false
                                : true
                            }
                          >
                            <option value="">Select base station</option>
                            {this.state.statelist.map((state) => {
                              return <option value={state}>{state}</option>;
                            })}
                          </select>
                        </span>
                      </div>
                      <div class="gstdetail">
                        <span class="detailinner_header"> Mentor Id </span>
                        <select
                          class="packageType drop-down-icon"
                          name="state"
                          value={this.state.campaign.mentorID}
                          onChange={(e) => {
                            this.setmentordetails(e);
                            e.target.style.removeProperty("border");
                            this.setState({
                              campaign: {
                                ...campaign,
                                mentorID: e.target.value,
                              },
                            });
                          }}
                          ref={this.state.validation.mentor}
                          disabled={
                            (campaign.kycstatus &&
                              campaign.kycstatus.status === "Submitted") ||
                            this.state.editmentor
                              ? false
                              : true
                          }
                        >
                          <option value="">Select your mentor</option>
                          {this.state.mentorlist &&
                            this.state.mentorlist.map((state) => {
                              return (
                                <option
                                  value={state.email}
                                >{`${state.name} (${state.email})`}</option>
                              );
                            })}
                        </select>
                      </div>
                      <div class="gstdetail">
                        <span class="detailinner_header"> Vendor SAP ID </span>
                        <span>
                          {" "}
                          <input
                            type="text"
                            name="sap_id"
                            ref={this.state.validation.sapId}
                            value={this.state.campaign.sapId}
                            onChange={(e) => {
                              e.target.style.removeProperty("border");
                              this.setState({
                                campaign: {
                                  ...campaign,
                                  sapId: e.target.value,
                                },
                              });
                              console.log(this.state.campaign.sapId);
                            }}
                            placeholder="Enter Vendor ID"
                            readOnly={
                              (campaign.kycstatus &&
                                campaign.kycstatus.status === "Submitted") ||
                              this.state.editmentor
                                ? false
                                : true
                            }
                            style={{
                              height: "40px",
                              border: "1px solid rgba(0, 0, 0, 0.3)",
                              borderRadius: "5px",
                              paddingLeft: "15px",
                            }}
                          />
                        </span>
                      </div>
                    </div>
                    {campaign.kycstatus &&
                      campaign.kycstatus.status === "Submitted" && (
                        <div class="gst_detail_inner">
                          {" "}
                          <div class="gstdetail">
                            <span class="detailinner_header">
                              {" "}
                              Mentor Phone Number{" "}
                            </span>
                            <span>{this.state.mentornum}</span>
                          </div>
                        </div>
                      )}
                  </div>

                  {campaign.kycstatus &&
                    campaign.kycstatus.status === "Submitted" && (
                      <div class="gst_detail">
                        <h2 class="campview-detail_header gst_detail_header">
                          Comments (Required only for Rejection)
                        </h2>
                        <div class="gst_detail_inner">
                          <div class="gstdetail">
                            <span>
                              {" "}
                              <textarea
                                style={{
                                  border: "1px solid rgba(0, 0, 0, 0.3)",
                                  borderRadius: "5px",
                                  paddingLeft: "15px",
                                }}
                                onChange={(e) => {
                                  let { campaign } = this.state;
                                  campaign.kycstatus.message = e.target.value;
                                  this.setState({ campaign });
                                  e.target.style.removeProperty("border");
                                }}
                                ref={this.state.validation.comments}
                                value={
                                  this.state.campaign.kycstatus
                                    ? this.state.campaign.kycstatus.message
                                    : ""
                                }
                                readOnly={
                                  campaign.kycstatus &&
                                  campaign.kycstatus.status === "Submitted"
                                    ? false
                                    : true
                                }
                                name="message"
                                cols="100"
                                rows="10"
                              ></textarea>
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                </div>

                <div className="camplist_detail_right">
                  <div class="view-btn_wrapper">
                    {campaign.kycstatus &&
                      campaign.kycstatus.status === "Verified" && this.state.adminInfo.role !== 'auditAdmin' && (
                        <button
                          className="viewdetail_back"
                          onClick={(e) => {
                            this.setState({
                              editmentor: true,
                            });
                            this.state.validation.station.current.scrollIntoView();
                          }}
                        >
                          Edit
                        </button>
                      )}
                    {this.state.campaign.previousKycStatuses &&
                      this.state.campaign.previousKycStatuses.length > 0 && (
                        <button
                          className="viewdetail_back"
                          onClick={this.hideshowhistory}
                        >
                          View History
                        </button>
                      )}

                    <button
                      className="viewdetail_back"
                      onClick={(e) => {
                        window.location.reload(true);
                      }}
                    >
                      Back
                    </button>
                  </div>
                  <div className="view-btn_wrapper">
                    {campaign.kycstatus &&
                      campaign.kycstatus.status === "Submitted" && (
                        <React.Fragment>
                          <button
                            className="viewdetail_back"
                            onClick={this.approveDSA}
                          >
                            Approve
                          </button>
                          <button
                            className="viewdetail_back"
                            onClick={this.rejectDSA}
                          >
                            Reject
                          </button>
                        </React.Fragment>
                      )}
                    {this.state.editmentor && (
                      <React.Fragment>
                        <button
                          className="viewdetail_back"
                          onClick={this.approveDSA}
                        >
                          Save
                        </button>
                        <button
                          className="viewdetail_back"
                          onClick={() =>
                            this.setState({
                              editmentor: false,
                            })
                          }
                        >
                          Cancel
                        </button>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        {this.state.historyview && (
          <StatusHistory
            isShowing={true}
            previousKycStatuses={this.state.campaign.previousKycStatuses}
            hide={this.hideshowhistory}
          />
        )}
        <ToastContainer />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
  };
};

export default connect(null, mapDispatchToProps)(ViewDSA);



// WEBPACK FOOTER //
// ./web/components/admin/dsa_management/viewDSA.js